import { useParams, usePathname } from "next/navigation";
import { useCallback } from "react";
import { isAbsoluteURL } from "@/utils/url/isAbsoluteURL";
import { isMailtoURL } from "@/utils/url/isMailtoURL";
import { removePathFallbackFromURL } from "@/utils/url/removePathFallbackFromURL";

export function useCreateInformaURL(relative = false) {
  const { state, domain } = useParams<{ state: string; domain: string }>();
  const pathname = usePathname();

  const createURL = useCallback(
    (uri: string) => {
      if (isAbsoluteURL(uri) || isMailtoURL(uri)) {
        return uri;
      }

      if (relative) {
        return removePathFallbackFromURL(`${pathname}/${uri}`);
      }

      return removePathFallbackFromURL(`/${state}/${domain}/${uri}`);
    },
    [state, domain, relative, pathname],
  );

  return { u: createURL };
}
